import { MatPageable } from '@core/table/mat-table';

export class Perfil {
    id: string;
    nome: string;
    idValue?: number;
}

export class PerfilElement {
    id: string;
    nome: string;
    ativo: string;
    paginacao?: MatPageable;
}

export class FiltroPerfil {
    nome?: string;
    idStatus: number | any;
}

export enum PerfilEnum {
    Administrador = '1',
    SuperUsuario = '2',
    Usuario = '3',
    Master = '4',
    Api = '5',
    Desenvolvedor = '7'
}